import * as React from 'react';
import { withOnClickTracking } from 'auto-tracking';
import { Box, rem, styled, theme } from 'design-system';
import { CheckboxInputProps } from 'preflight-core';

import { ErrorText, Label } from './base-input';

const StyledCheckboxContainer = styled('label', {
  position: 'relative',
  display: 'inline-block',
  verticalAlign: 'middle',
});

const StyledCheckboxInput = styled('input', {
  // all: 'initial',
  appearance: 'none',
  width: rem(22),
  height: rem(22),
  borderRadius: rem(6),

  '-webkit-appearance': 'none',
  '-moz-appearance': 'none',
  border: `1px solid ${theme.colors.gray8}`,
  backgroundColor: theme.colors.gray1,
  '&:active': {
    backgroundColor: theme.colors.gray3,
  },
  '&:checked': {
    backgroundColor: theme.colors.blue9,
  },
  '&:focus-visible': {
    outline: `${theme.colors.yellow9} solid ${rem(2)}`,
    outlineOffset: rem(2),
  },
  '&:checked + div': {
    visibility: 'visible',
  },
  variants: {
    error: {
      false: {},
      true: {
        '&:not(:checked)': {
          backgroundColor: theme.colors.red1,
          borderColor: theme.colors.red8,
        },
      },
    },
  },
  defaultVariants: {
    error: 'false',
  },
});

const StyledCheckMarkIcon = styled('div', {
  position: 'absolute',
  top: -2,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  visibility: 'hidden',
});

const StyledCheckboxInputWithTrack = withOnClickTracking(StyledCheckboxInput);

export const CheckboxInputNew: React.FC<{
  disabled: boolean;
  error?: string;
  label: JSX.Element;
  name: string;
  props: CheckboxInputProps;
  height?: number;
  width?: number;
}> = ({ disabled, error, label, name, props, width, height }) => {
  return (
    <>
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        <StyledCheckboxContainer>
          <StyledCheckboxInputWithTrack
            disabled={disabled}
            name={name}
            id={name}
            {...props}
            state={error ? 'error' : 'idle'}
            style={{
              height: height ? height : undefined,
              width: width ? width : undefined,
            }}
          />
          <StyledCheckMarkIcon>
            <svg
              width="11"
              height="9"
              viewBox="0 0 11 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4.33333L2.77461 6.93609C3.14231 7.47538 3.91972 7.52356 4.35119 7.03378L9.66667 1"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </StyledCheckMarkIcon>
        </StyledCheckboxContainer>
        <Label disabled={disabled} htmlFor={name}>
          {label}
        </Label>
      </Box>
      {error ? <ErrorText>{error}</ErrorText> : undefined}
    </>
  );
};
